"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyPaymentInfo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var MonthlyPaymentInfo = /** @class */ (function () {
    function MonthlyPaymentInfo() {
    }
    MonthlyPaymentInfo.renderMonthlyPaymentInfo = function (renewalChangesPage) {
        if (renewalChangesPage === void 0) { renewalChangesPage = false; }
        return ((0, jsx_runtime_1.jsx)("div", { className: "banner banner-info", children: (0, jsx_runtime_1.jsxs)("p", { className: "mb-0", children: ["The cost of your insurance and the interest charged is spread over the year, so paying for your insurance ", (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "monthly will cost more than if you paid annually" }), ". Please check you can afford the monthly payments.", (0, jsx_runtime_1.jsx)("br", {}), !renewalChangesPage && (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "You'll just need your bank details ready so we can set up a Direct Debit for you." })] }) }));
    };
    return MonthlyPaymentInfo;
}());
exports.MonthlyPaymentInfo = MonthlyPaymentInfo;
//# sourceMappingURL=MonthlyPaymentInfo.js.map